var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 220 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_1382_77246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.892 33.3638V33.8638H102.392H123.538C123.917 33.8638 124.158 34.2687 123.977 34.6019L103.785 71.8876C103.538 72.3438 102.845 72.1683 102.845 71.6495V42.24V41.74H102.345H81.1794C80.8004 41.74 80.5592 41.3349 80.7398 41.0017L100.953 3.70563C101.2 3.24958 101.892 3.42515 101.892 3.94387V33.3638Z",
    fill: "#FFA722",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.626 69.5816H122.598L120.918 73.7272H114.758L124.182 52.375H130.133L139.589 73.7272H133.305L131.626 69.5816ZM129.858 65.1291L127.11 58.2942L124.366 65.1291H129.858Z",
    fill: "#FFA722"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_1382_77246",
    x: -0.5,
    y: 0,
    width: 220.09,
    height: 250.596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.62889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.698039 0 0 0 0 0.0392157 0 0 0 0.0899666 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1382_77246"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.3176
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66004
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.698039 0 0 0 0 0.0392157 0 0 0 0.129246 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1382_77246",
    result: "effect2_dropShadow_1382_77246"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.8955
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.698039 0 0 0 0 0.0392157 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1382_77246",
    result: "effect3_dropShadow_1382_77246"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 21.2195
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.93452
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.698039 0 0 0 0 0.0392157 0 0 0 0.190754 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1382_77246",
    result: "effect4_dropShadow_1382_77246"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 39.6887
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.711
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.698039 0 0 0 0 0.0392157 0 0 0 0.230033 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_1382_77246",
    result: "effect5_dropShadow_1382_77246"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 95
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.698039 0 0 0 0 0.0392157 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_1382_77246",
    result: "effect6_dropShadow_1382_77246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_1382_77246",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashIcon);
export default __webpack_public_path__ + "static/media/flash_icon.58e5940f023841b08f2eed36ebdc1e31.svg";
export { ForwardRef as ReactComponent };